export function setCoachingTracks(state, payload) {
    state.coachingTracks = payload;
}

export function resetStore(state) {
    state.coachingTracks = [];
}